import slugify from "./slugify";
import mapProductItem from "./map-product-item";
import mapCartItem from "./map-cart-item";
import generateItemUid from "./generate-item-uid";
import priceFormatter from "./price-formatter";
import quantityFormatter from "./quantity-formatter";
import decimalFormatter from "./decimal-formatters";
import capitalize from "./capitalize";

export default {
    slugify,
    mapProductItem,
    mapCartItem,
    generateItemUid,
    priceFormatter,
    quantityFormatter,
    decimalFormatter,
    capitalize,
}

jQuery( document ).ready(function() {
    jQuery('body').on('click', '.faq-question', function () {
        if (jQuery(this).parents('.faq-section.active').length) {
            jQuery('body .faq-section').removeClass('active').find('.faq-content').slideUp(2);
            // jQuery(this).parent().find('.faq-content').slideDown();
        }else{
            jQuery('body .faq-section').removeClass('active').find('.faq-content').slideUp(2);
            jQuery(this).parent().find('.faq-content').slideDown(2);
            jQuery(this).parent().addClass('active');
        }
    })
});
